import {RouterModule, Routes} from '@angular/router';
import { Component } from '@angular/core';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { LoginComponent } from './login/login/login.component';

const appRoutes: Routes = [
        {path: 'login', component: LoginComponent},
        {path: '**', component: NopagefoundComponent}
];

export const APP_ROUTES = RouterModule.forRoot(appRoutes, { useHash: true});
